import validate from 'validate.js'

const constraints = {
  recurringId: {
    presence: true
  },
  solveResolution: {
    presence: true
  }
}

export default (data) => {
  return validate(data, constraints)
}
